import { render, staticRenderFns } from "./giftExchangeAdd.vue?vue&type=template&id=2a342094&scoped=true&"
import script from "./giftExchangeAdd.vue?vue&type=script&lang=js&"
export * from "./giftExchangeAdd.vue?vue&type=script&lang=js&"
import style0 from "./giftExchangeAdd.vue?vue&type=style&index=0&id=2a342094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a342094",
  null
  
)

export default component.exports